import { render } from "./SidebarItemLink.vue?vue&type=template&id=ba0a99ca"
import script from "./SidebarItemLink.vue?vue&type=script&lang=ts"
export * from "./SidebarItemLink.vue?vue&type=script&lang=ts"
script.render = render

export default script